function minRingThickness(node, region) {
    var minThicknessPixel = 2;
    var minThickness = region.coord.radius / minThicknessPixel;
    return Math.min(minThickness, node.value);
}
export default {
    type: 'padding',
    usage: 'assign',
    expression: minRingThickness,
};
//# sourceMappingURL=min-ring-thickness.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/util/responsive/constraints/min-ring-thickness.js
// module id = null
// module chunks = 